/* Load demonstration videos near the viewport, without delaying checkout scripts. */
(() => {
  const selector = 'video[data-nuv-video-src]';
  const visible = new Set();
  const observed = new WeakSet();

  function play(video) {
    if (!video.getAttribute('src')) {
      video.src = video.dataset.nuvVideoSrc;
      video.load();
    }
    if (document.hidden) return;
    const promise = video.play();
    if (promise) promise.catch(() => {});
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const {target: video, isIntersecting} of entries) {
          if (isIntersecting) {
            visible.add(video);
            play(video);
          } else {
            visible.delete(video);
            video.pause();
          }
        }
      }, {rootMargin: '300px 0px'})
    : null;

  function init(root = document) {
    root.querySelectorAll(selector).forEach((video) => {
      if (observed.has(video)) return;
      observed.add(video);
      if (observer) observer.observe(video);
      else { visible.add(video); play(video); }
    });
  }

  document.addEventListener('visibilitychange', () => {
    for (const video of visible) {
      if (!video.isConnected) { visible.delete(video); continue; }
      if (document.hidden) video.pause();
      else play(video);
    }
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((video) => {
      observer?.unobserve(video);
      observed.delete(video);
      visible.delete(video);
      video.pause();
    });
  });
  init();
})();
